import { createContext, useContext } from 'react';
import useSetupBulkActions from 'framework-listing-lib/internal/Table/hooks/useSetupBulkActions';
import { jsx as _jsx } from "react/jsx-runtime";
const ListingLibBulkActionsContext = /*#__PURE__*/createContext(undefined);
export default function ListingLibBulkActionsProvider({
  bulkActionProps,
  data,
  children,
  rowProps
}) {
  const value = useSetupBulkActions({
    bulkActionProps,
    data,
    rowProps
  });
  return /*#__PURE__*/_jsx(ListingLibBulkActionsContext.Provider, {
    value: value,
    children: children
  });
}
export function useListingLibBulkActions() {
  const context = useContext(ListingLibBulkActionsContext);
  if (context === undefined) {
    throw new Error('useListingLibBulkActions must be used within a ListingLibBulkActionsProvider');
  }
  return context;
}